import React, { useEffect, useMemo, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import OrganizeSharedSafariModal from "./createfixedsafri/OrganizeSharedSafariModal";
import SharedsafariCard from "../SharedSafari/SharedsafariCard";
import apiCall from "../Api/api";

import SelectedFiltersSharedSafari from "./SelectedFiltersSharedSafari";
import { useMasterContext } from "../../provider/MasterProvider";
import ShareSafariFilter from "./ShareSafariFilter";
import SharedsafariCardSkeleton from "components/common/Skeleton/safari/SharedsafariCardSkeleton";
import { useSharedSafariContext } from "provider/ShareSafariProvider";
import { useScreenSize } from "provider/ScreenSizeProvider";
import ShareSafariMobileFilter from "./ShareSafariMobileFilter";
import CreateFixedSharedSafariModal from "../SharedSafari/CreateFixedSharedSafariModal";

const SharedSafariList = () => {
  return (
    <SharedSafariContent />
  );
};

const SharedSafariContent = () => {
  const { sharedSafariData, summary, filters, toggleOragnize, sharedSafariDispatch } = useSharedSafariContext();
  const { safariSortBy } = useMasterContext();
  const { isMobileView } = useScreenSize();
  const [pageIndex, setPageIndex] = useState(1);
  const [show, setShow] = useState(false);
  const handleShow = () => {
    sharedSafariDispatch({ type: "ORGANIZE_SHARE_SAFARI_TOGGLE", payload: true });
  }
  const handleClose = () => setShow(false);
  const [showFixed, setShowFixed] = useState(false);
  const handleShowFixed = () => setShowFixed(true);
  const handleCloseFixed = () => setShowFixed(false);
  const [loading, setLoading] = useState(true);
  const [showFilter, setShowFilter] = useState(false);


  const handleFilterClick = () => {
    setShowFilter(true); // or toggle with !showFilter if you want toggle behavior
  };
  const handleSortChange = (e) => {
    const value = Number(e.target.value);
    updateFilter("custom_sort_by", value);
  };
  const updateFilter = (name, value) => {
    sharedSafariDispatch({
      type: "UPDATE_SHARED_SAFARI_FILTER",
      payload: { [name]: value },
    });
  };

  useEffect(() => {
    const fetchSharedSafaris = async () => {
      try {
        setLoading(true);
        const queryParams = new URLSearchParams();

        Object.entries(filters).forEach(([key, value]) => {
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((v) => queryParams.append(`${key}[]`, v));
          } else if (value !== 0 && value !== null && value !== "") {
            queryParams.append(key, value);
          }
        });

        if (summary?.pageSize) {
          queryParams.append("pageSize", summary.pageSize);
        }
        if (pageIndex) {
          queryParams.append("page", pageIndex);
        }

        const response = await apiCall({
          url: `sharesafari?${queryParams.toString()}`,
          method: "GET",
        });
        if (response?.status === 200) {
          if (response?.data?.errors) {
            const errors = response?.data.errors;
            // Dynamically set errors based on the response
            console.error(errors);
          } else {
            const postData = response?.data?.share_safari?.data || [];
            const summary = response?.data?.share_safari?.summary;
            if (pageIndex === 1) {
              sharedSafariDispatch({
                type: "SET_SHARED_SAFARI_DATA",
                payload: postData,
              });
            } else {
              sharedSafariDispatch({
                type: "APPEND_SHARED_SAFARI_DATA",
                payload: postData,
              });
            }

            sharedSafariDispatch({
              type: "SHARED_SAFARI_SUMMARY",
              payload: {
                total: summary.total,
                page: summary.page,
                pageSize: summary.pageSize,
                total_page: summary.total_page,
              },
            });
          }
        }
      } catch (err) {
        console.error("Error fetching safaris:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchSharedSafaris();
  }, [summary?.pageSize, filters, pageIndex]);

  const processedSharedSafari = useMemo(() => {
    return sharedSafariData?.map((sharedSafari) => ({
      ...sharedSafari,
    }));
  }, [sharedSafariData, pageIndex]);

  return (
    <>
      <section className="banner_section-inner packagebnner position-relative">
        <picture className="position-relative">
          <source
            srcSet={"/img/baneer1719164625.jpg"}
            media="(max-width:576px)"
            type="image/jpg"
          />
          <img
            src="/img/baneer1719164625.jpg"
            className="d-block w-100 banner_search"
            alt="banner"
            type="image/jpg"
            loading="lazy"
          />
        </picture>
        <div className="banner_searchBox">
          <Container>
            <Row>
              <Col xs={12}>
                <div className="headingBnner_inner">
                  <h1>Join or Organize a Shared Safari </h1>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>
      <section className="articals_wrapper py-3 px-md-5 px-xl-0 px-3">
        <Row className="justify-content-center my-4 margin_bottomfooter row">
          <Col xl={12} xxl={10} lg={12}>
            <Row className="justify-content-center">
              <Col lg={3} xl={2} xxl={2} className="ps-lg-0 mb-4">
                <div className="right_button mb-lg-4 mb-2 position-relative galssset2">
                  <button className="btn_newsafari organizeBtn newbg d-block text-center " onClick={handleShow}>+ Organize a Shared Safari</button>
                  <div class="qoute_write  text-center text-white"><h5 class="mb-0 " style={{ fontSize: "14px" }}>comming soon </h5></div>
                </div>
                {/* <div className="right_button mb-lg-4 mb-2 position-relative ">
                  <button className="btn_newsafari organizeBtn newbg d-block text-center " onClick={handleShowFixed}>+ Create Fixed Departure</button>
                </div>

                <div className="right_button mb-lg-4 mb-2 position-relative ">
                  <button className="btn_newsafari organizeBtn newbg d-block text-center " onClick={handleShow}>+ Organize a Shared Safari</button>

                </div> */}

                {!isMobileView && <ShareSafariFilter />}
                {isMobileView && <div
                  id="targetDiv"
                  className="mobileDive"
                  style={{ display: showFilter ? "block" : "none" }}
                >
                  <ShareSafariMobileFilter onCancel={() => setShowFilter(false)} />
                </div>
                }
              </Col>
              {isMobileView && <Col xs={12} className="px-0 d-lg-none">
                <div className="top_mobilefilter d-flex gap-2  justify-content-between align-items-center w-100 mb-4">
                  <div className="left_text">
                    <p className="mb-0">
                      There are currently <strong> {processedSharedSafari.length}</strong>{" "}
                      active shared safaris
                    </p>
                  </div>
                  <div className="right-select mobile_serach mb-md-0 ">
                    <div className="input_check pb-0">
                      <div
                        className="filter_searchbox"
                        onClick={handleFilterClick}
                      >
                        <span>
                          Filter <i className="fa-solid fa-chevron-down"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>}
              <Col lg={9} xl={9} xxl={9} className=" pt-3 bg-whitesetnew">
                <Row>
                  {!isMobileView && <Col xs={12}>
                    <div className="topfilter d-lg-flex d-none justify-content-between align-items-center flex-wrap w-100 mb-2">
                      <div className="left_text">
                        <p className="mb-0">
                          There are currently
                          <strong> {processedSharedSafari.length}</strong>{" "}
                          active shared safaris
                        </p>
                      </div>
                      <div className="right-select">
                        <div className="input_check pb-0 mb-3">
                          <div className="form-group field-sharesafarisearch-custom_sort_by">
                            <select
                              id="sharesafarisearch-custom_sort_by"
                              name="custom_sort_by"
                              className="form-control custom_sort_by_input"
                              value={filters?.custom_sort_by}
                              onChange={handleSortChange}
                            >
                              {safariSortBy?.map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>}
                  <SelectedFiltersSharedSafari />
                </Row>
                <Row className="row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-lg-2 row-cols-xl-3 row-cols-xxl-3 g-lg-3 gx-lg-4 gx-xxl-4 pt-1 row">
                  {Array.isArray(processedSharedSafari) &&
                    processedSharedSafari.length > 0 ? (
                    <>
                      {processedSharedSafari.map((safari, index) => (
                        <Col
                          className="mb-xl-1  mb-md-3 mb-4"
                          key={safari.slug || index}
                        >
                          <SharedsafariCard safari={safari} page="sharesafari" />
                        </Col>
                      ))}
                    </>
                  ) : loading ? (
                    <SharedsafariCardSkeleton count={6} />
                  ) : (
                    <p>No safaris available</p>
                  )}
                </Row>
                <div className="d-flex justify-content-center my-4">
                  {loading ? (
                    <div
                      className="spinner-border loading-spinner"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    summary?.page < summary?.total_page && (
                      <button
                        className="join_btn newbgjoin mt-sm-0 mt-2"
                        onClick={() => setPageIndex((prev) => prev + 1)}
                      >
                        Show More Safaris
                      </button>
                    )
                  )}
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </section>
      {toggleOragnize && <OrganizeSharedSafariModal show={show} handleClose={handleClose} />}
      <CreateFixedSharedSafariModal showFixed={showFixed} handleCloseFixed={handleCloseFixed} />
      {/* <BackToTop /> */}
    </>
  );
};

export default SharedSafariList;
